module.exports = __webpack_public_path__ + "static/media/marker_icon.976c2b8d.svg";